import {currencyConverter} from '../../utility/methods';
import {t} from 'i18next';
import MediaQuery from "react-responsive";

const VehicleDetailsLargeScreen = ({ getCompareImages, activeLocale }) => (
    <MediaQuery minWidth="900px">
        <div className={'vehicle-details'}>
            <div
                className={'model-year-make'}>{getCompareImages[0]?.year} {getCompareImages[0]?.make}</div>
            <div
                className={'vehicle-trim'}>{getCompareImages[0]?.model} {getCompareImages[0]?.trim}</div>
            <div className={'vehicle-price'}>{t('overview.startingFrom')}</div>
            <div className={'vehicle-trim-price'}>
                {currencyConverter(getCompareImages[0]?.pricing.msrp, activeLocale)}<span>*</span>
            </div>
        </div>
    </MediaQuery>
);

export default VehicleDetailsLargeScreen;
